module.exports = __webpack_public_path__ + "assets/img/logo.6a4d689c.png";